export default "__VITE_ASSET__MMy$yPuC__"